import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash-es';
import { ComparatorModel } from 'client/data/models/comparator';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';

// Components
import { StyleLink } from 'site-modules/comparator/components/style-link/style-link';

export function FeatureStylesListUI({ otherStyles = [], chooseStyle }) {
  return (
    <ul className="list-unstyled m-0">
      {otherStyles.map(style => (
        <li key={style.styleId}>
          <StyleLink style={style} onClick={chooseStyle} />
        </li>
      ))}
    </ul>
  );
}

FeatureStylesListUI.propTypes = {
  chooseStyle: PropTypes.func.isRequired,
  otherStyles: PropTypes.arrayOf(
    PropTypes.shape({
      submodelName: PropTypes.string,
      baseMSRP: PropTypes.number,
      styleName: PropTypes.string,
      styleId: PropTypes.number,
    })
  ),
};

export const FeatureStylesListStateToProps = {
  otherStyles: bindToPath(
    ({ styleId, featureCategorySlug, featureNameSlug }) =>
      `styles["${styleId}"].features["${featureCategorySlug}"]["${featureNameSlug}"].otherStyles`,
    ComparatorModel,
    otherStyles => sortBy(otherStyles, 'baseMSRP')
  ),
};

export const FeatureStylesList = connectToModel(FeatureStylesListUI, FeatureStylesListStateToProps);
